import React from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import { MessageCircle, Minus, Maximize2, Minimize2, X, RefreshCw } from 'lucide-react';
import type { WidgetState } from '../types/chat.types';

interface ChatHeaderProps {
  widgetState: WidgetState;
  hasMessages: boolean;
  loading: boolean;
  onToggleMinimize: () => void;
  onToggleFullscreen: () => void;
  onClose: () => void;
  onReset: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  widgetState,
  hasMessages,
  loading,
  onToggleMinimize,
  onToggleFullscreen,
  onClose,
  onReset,
}) => {
  return (
    <Box
      sx={{
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        p: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <MessageCircle size={20} />
        <Typography variant="subtitle1" fontWeight="bold">
          AI Assistant (Beta)
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        {hasMessages && (
          <Tooltip title="Reset conversation">
            <IconButton size="small" onClick={onReset} disabled={loading} sx={{ color: 'inherit' }}>
              <RefreshCw size={18} />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip title={widgetState === 'fullscreen' ? 'Exit fullscreen' : 'Fullscreen'}>
          <IconButton size="small" onClick={onToggleFullscreen} sx={{ color: 'inherit' }}>
            {widgetState === 'fullscreen' ? <Minimize2 size={18} /> : <Maximize2 size={18} />}
          </IconButton>
        </Tooltip>
        {widgetState !== 'fullscreen' && (
          <IconButton size="small" onClick={onToggleMinimize} sx={{ color: 'inherit' }}>
            <Minus size={18} />
          </IconButton>
        )}
        <IconButton size="small" onClick={onClose} sx={{ color: 'inherit' }}>
          <X size={18} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ChatHeader;
